<template>
  <div class="footer">
    <footer>
      <div class="layout">
        <div>
          <nav class="topnav">
            <a href @click.prevent="showModal=true">Contact Us</a>
            <a href="https://www.pilates.com/company/balanced-body-privacy-policy" target="_blank">Privacy</a>
            <a href="https://www.pilates.com/store/affirm-financing" target="_blank">Affirm Financing</a>
            <a href="https://video.pilates.com/categories/contrology" target="_blank">Streaming Workout Videos</a>
            <a href="https://www.pilates.com/legal" target="_blank">Legal</a>
          </nav>
          <nav class="bottomnav">
            <a href="https://www.pilates.com/accessibility" target="_blank">Accessibility</a>
            <a href="https://www.pilates.com/warranty" target="_blank">Warranty</a>
            <a href="https://www.pilates.com/returns-policy" target="_blank">Returns</a>
            <a href @click.prevent="showConsent=true">Cookie Preferences</a>
          </nav>
        </div>
        <show-at breakpoint="mediumAndBelow">
          <a href="https://www.pilates.com/" title="Visit Balanced Body">
            <img src="@/assets/bb-logo-vert.svg" alt="Balanced Body logo" class="logo" />
          </a>
        </show-at>
      </div>
      <div class="icons">
        <a
          href="https://www.facebook.com/contrologybybalancedbody/"
          title="Visit us on Facebook"
          target="_blank"
        >
          <img src="@/assets/icon-fb-thin.svg" alt="Facebook logo" class="social" />
        </a>
        <a
          href="https://www.instagram.com/contrology.bb/"
          title="Visit us on Instagram"
          target="_blank"
        >
          <img src="@/assets/icon-insta-thin.svg" alt="Instagram logo" class="social" />
        </a>
      </div>
      <show-at breakpoint="large">
        <a href="https://www.pilates.com/" title="Visit Balanced Body" class="logo-link">
          <img src="@/assets/bb-logo-blk.svg" alt="Balanced Body logo" class="logo" />
        </a>
      </show-at>
    </footer>

    <!-- Contact Us form modal -->
    <Modal v-if="showModal" @close="showModal = false">
      <div slot="header">
        <h3>Questions, Comments or Product Feedback? We want to hear it! <br />Please fill-out the form below and we will respond within 24 Hours.</h3>
      </div>
      <div slot="body">
        <form
          method="post"
          id="form2"
          action=""
          @submit="validateForm"
          class="elq-form"
        >

          <div>
            <label for="field0">Full Name</label>
            <br />
            <input
              id="field0"
              v-model="fullname"
              name="fullname"
              type="text"
              placeholder="Enter Full Name"
              autocomplete="off"
            />
          </div>

          <div>
            <label for="field1">Email Address</label>
            <br />
            <input
              id="field1"
              v-model="emailaddress"
              name="emailaddress"
              type="email"
              placeholder="Enter Email Address"
              autocomplete="off"
            />
          </div>

          <div>
            <label for="field2">Studio Name (optional)</label>
            <br />
            <input
              id="field2"
              v-model="studio"
              name="studio"
              type="text"
              placeholder="Enter Studio Name"
              autocomplete="off"
            />
          </div>

          <div>
            <label for="field5">Country</label>
            <br />
            <select v-model="country" name="country" id="field5">
              <option disabled value="">Please select one</option>
              <option v-for="(country, index) in countries" :key="index" :value="country.name">
                {{ country.name }}
              </option>
            </select>
          </div>

          <div>
            <label for="field3">Reason for contact</label>
            <br />
            <textarea
              id="field3"
              v-model="request"
              name="request"
            />
          </div>

          <div>
            <input type="submit" value="Submit" class="submit-button" :disabled="disabled" />
          </div>
          <p class="error" v-if="error.length">{{ error }}</p>
          <span v-show="message" class="error">{{ message }}</span>
        </form>
      </div>
      <div slot="footer" style="text-align:center">Immediate questions? Please call us at 916-388-2838.</div>
    </Modal>
    <!-- Contact Us form modal end -->

    <gdpr-banner :updateConsent="showConsent" :showConsent.sync="showConsent" />
  </div>
</template>

<script>
import ApiService from '@/js/ApiService.js';
import { showAt } from "vue-breakpoints";
import Modal from "@/components/Modal.vue";
import GdprBanner from "@/components/GdprBanner.vue";

export default {
  name: "appfooter",

  components: {
    showAt,
    Modal,
    GdprBanner
  },

  data() {
    return {
      showModal: false,
      showConsent: false,
      error: '',
      message: '',
      emailaddress: '',
      fullname: '',
      studio: '',
      request: '',
      country: '',
      response: '',
      bbAffiliateID: '',
      disabled: false,
      countries: []
    };
  },

  created() {
    this.fetchCountryList();
  },

  mounted() {
    // this.isAffiliateRef();
    // this.setAffiliateCookie();
  },

  methods: {
    fetchCountryList() {
      this.error = false;
      this.loading = true;
      ApiService.getCountryList()
      .then(response => {
        this.loading = false;
        this.countries = response.data;
      })
      .catch(error => {
        this.loading = false;
        this.error = true;
        this.message = error;
        console.error(error);
      })
    },

    // isAffiliateRef() {
    //   let idString = this.$route.query.bbAffiliateID ? this.$route.query.bbAffiliateID : "";
    //   if ( idString !== "" ) {
    //     idString = idString.replace(/[^0-9a-zA-Z]/g,'');
    //     this.bbAffiliateID = idString;
    //   }
    // },

    // setAffiliateCookie() {
    //   const cookieExists = this.$cookies.isKey("affiliate");
    //   if (this.bbAffiliateID && !cookieExists) {
    //     this.$cookies.set("affiliate", this.bbAffiliateID, "30d","/",".pilates.com");
    //   }
    // },
    
    validateForm(e) {
      this.error = "";
      if (!this.emailaddress || !this.fullname || !this.country) {
        this.error = "Please complete all required fields";
      } else if (this.emailaddress.length > 35 || this.fullname.length > 35 || this.country.length > 35) {
        this.error = "Too many characters. Please try again.";
      } else if (!this.validEmail(this.emailaddress)) {
        this.error = "Please enter a valid email address";
      }
      if (this.error === "") {
        this.submitForm();
      }
      e.preventDefault();
    },

    validEmail(email) {
      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    submitForm() {
      this.message = "Sending..."
      this.disabled = true;
      const url = 'https://sites.pilates.com/email-webhooks/contrology'
      const headers = {
        "Content-Type": "application/json"
      };
      var formElement = document.querySelector("#form2");
      var formdata = new FormData(formElement);
      const values = Object.fromEntries(formdata.entries());
      var requestOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(values),
      };
      

      fetch(url, requestOptions)
      .then((response) => {
        this.response = response;
        if (response.status !== 200) {
          throw Error((this.message = 'POST error, status code: ' + response.status));
        }
        this.message = 'Thank you for your message!';
        return this.message;
      })
      .catch((error) => {
        this.message = error;
        return error;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.footer {
  margin: 30px 5%;
}

.layout {
  display: flex;
  justify-content: space-between;
}

nav {
  display: flex;
  flex-flow: column nowrap;
}

nav a {
  font-family: var(--roboto);
  font-size: 0.875em;
  color: var(--black);
  font-weight: 400;
  line-height: 2;
  text-decoration: none;
}

nav a:hover {
  text-decoration: underline;
}

.icons {
  display: flex;
  align-items: center;
  border-top: 1px solid var(--black);
  border-bottom: 1px solid var(--black);
  margin: 20px 0;
}

.icons .social {
  display: block;
  padding: 10px 20px 10px 0;
  width: 60px;
  height: 60px;
}

// Form modal
h2 {
  text-align: center;
}

::v-deep .modal-container {
  background-image: url(https://s3.amazonaws.com/s3.pilates.com/img/landing-pages/contrology/sandpaper.png);
  text-align: left;
}

form div {
  margin: 10px 0;
}

label {
  font-family: var(--roboto);
  font-weight: 400;
  font-size: 0.875em;
  line-height: 1.614;
}

input,
textarea,
select {
  border: 1px solid #5f6062;
  padding: 10px;
  width: 100%;
  max-width: 400px;
  font-size: 1em;
  font-family: var(--roboto);
}

input[type="submit"] {
  width: 100%;
  max-width: 400px;
  height: 40px;
  font-size: 1em;
  margin-top: 10px;
  border-color: var(--black);
  background-color: var(--black);
  color: var(--white);
  -webkit-transition: 0.2s;
  transition: 0.2s;
  cursor: pointer;
  -webkit-appearance: none;
  border-radius: 0;
}

input[type="submit"]:hover {
  background-color: gray;
}

.f1 {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 0;
  width: 0;
  z-index: -1;
}

.error {
  color: #990101;
  font-size: 14px;
  margin-top: -5px;
  display: block;
  position: absolute;
  font-weight: bold;
}

@media only screen and (min-width: 520px) {
  form {
    position: relative;
    left: 50%;
    transform: translateX(-200px);
  }
}

@media only screen and (min-width: 1214px) {
  .footer {
    margin: 10px 10%;
  }

  footer {
    display: flex;
    align-items: center;
    width: 100%;
  }

  nav.topnav,
  nav.bottomnav {
    display: block;
    // flex-flow: row nowrap;
    // align-items: center;
  }

  nav a {
    padding-right: 20px;
  }

  .icons {
    border: none;
    order: 1;
    justify-self: flex-start;
  }

  .layout {
    order: 2;
    justify-self: flex-start;
  }

  .logo-link {
    justify-self: flex-end;
    margin-left: auto;
    order: 3;
  }
}
</style>
